import "rsuite/dist/rsuite.min.css";
import "./App.css";
import { CustomProvider } from "rsuite";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Components/pages/Login";
import { GlobalContextProvider, useGlobalContext } from "./GlobalContext";
import { useEffect } from "react";
import Dashboard from "./Components/pages/Dashboard";
import NetworkService from "./NetworkService";
import UsersPage from "./Components/pages/UsersPage";
import UserPage from "./Components/pages/UserPage";
import RidesPage from "./Components/pages/RidesPage";
import TransactionsPage from "./Components/pages/TransactionsPage";
import InvoicesPage from "./Components/pages/InvoicesPage";
import ForgotPasswordPage from "./Components/pages/ForgotPasswordPage";
import ResetPasswordPage from "./Components/pages/ResetPasswordPage";
import RegisterPage from "./Components/pages/RegisterPage";
import RideOrderPage from "./Components/pages/RideOrderPage";
import ToasterBridge from "./Components/ToasterBridge";
import { ROUTES } from "./constants/routes";

function App() {
  return (
    <CustomProvider>
      <ToasterBridge />
      <GlobalContextProvider>
        <RoutesWrap />
      </GlobalContextProvider>
    </CustomProvider>
  );
}

const RoutesWrap = () => {
  const { user: a } = useGlobalContext();

  const [user] = a;

  useEffect(() => {
    NetworkService.setAuthToken(user?.authorisation?.token ?? null);
  }, [user?.authorisation?.token]);

  return (
    <BrowserRouter>
      <Routes>
        {!user && <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />}
        {!user && <Route path={ROUTES.RESET_PASSWORD} element={<ResetPasswordPage />} />}
        {!user && <Route path={ROUTES.LOGIN} element={<Login />} />}
        {!user && <Route path={ROUTES.REGISTER} element={<RegisterPage />} />}
        {user && <Route path={ROUTES.ROOT} element={<Dashboard />} />}
        {user && <Route path={ROUTES.SERVICES} element={<RidesPage />} />}
        {user && <Route path={ROUTES.USER_DETAILS} element={<UserPage />} />}
        {user && <Route path={ROUTES.USERS} element={<UsersPage />} />}
        {user && <Route path={ROUTES.TRANSACTIONS} element={<TransactionsPage />} />}
        {user && <Route path={ROUTES.INVOICES} element={<InvoicesPage />} />}
        {user && <Route path={ROUTES.ORDER_RIDE} element={<RideOrderPage />} />}

        <Route path="*" element={user ? <Navigate to={ROUTES.ROOT} /> : <Navigate to={ROUTES.LOGIN} />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
